import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import BunkerShipSelect from "./BunkerShipSelect";
import { PieChart, Pie, Cell } from "recharts";
import BunkerTurnover from "./BunkerTurnover";
import DefaultNotFound from "../../Misc/DefaultNotFound";

export default class Bunker extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      cistern: [],
      volume: {},

      turnoverCistern: false,
      checkedCisterns: [],
    };
  }
  componentDidMount() {
    this.load();
    this.renderButtons();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.shipId !== this.props.shipId) {
      this.load();
    }
    this.renderButtons();
  }
  load = async () => {
    const { shipId } = this.props;
    this.setState({ pending: true });
    let cistern = [];
    let volume = {};
    if (shipId) {
      cistern = await this.context.api.qa("/cistern/list", {
        filter: { ship: shipId },
      });

      let cisternIDs = [];
      let cisternQuery = [];
      cistern.forEach((item) => {
        cisternIDs.push(item.id);
        cisternQuery.push({ id: item.id });
      });

      let volumes = await this.context.api.qa("/cistern/volume", cisternQuery);
      if (Array.isArray(volumes)) {
        volumes.forEach((item, idx) => {
          if (item) {
            let cisternId = cisternIDs[idx];
            volume[cisternId] = item.volume;
          }
        });
      }
    }
    this.setState({ pending: false, cistern: cistern || [], volume });
  };

  onTurnoverClose = () => {
    this.setState({
      turnoverCistern: false,
    });
  };

  onTurnoverOpen = (turnoverCistern) => {
    this.setState({ turnoverCistern });
  };

  onCisternCheck = (id) => {
    this.setState((state) => {
      let checkedCisterns = state.checkedCisterns;
      let idx = checkedCisterns.indexOf(id);
      if (idx !== -1) {
        checkedCisterns.splice(idx, 1);
      } else {
        checkedCisterns.push(id);
      }
      return { checkedCisterns };
    });
  };

  onMakeOrder = () => {
    const { checkedCisterns } = this.state;
    const { shipId } = this.props;
    this.context.redirect(
      "/bunkerorder/add/?ship=" +
        shipId +
        "&append=" +
        checkedCisterns.join(",")
    );
  };

  onAddData = () => {
    const { checkedCisterns } = this.state;
    const { shipId } = this.props;
    this.context.redirect(
      "/bunkerupdate/add/?ship=" +
        shipId +
        "&append=" +
        checkedCisterns.join(",")
    );
  };

  renderButtons = () => {
    if (this.props.embed) return;
    this.context.actionsSet(
      <>
        <button
          onClick={this.onAddData}
          disabled={this.state.checkedCisterns.length < 1}
          title="Внести данные по содержимому бункера"
          className={`btn btn-light mr-2`}
        >
          <i className="fa fa-dashboard mr-2"></i>
          Внести данные
        </button>
        <button
          onClick={this.onMakeOrder}
          disabled={this.state.checkedCisterns.length < 1}
          title="Создать заявку на бункеровку"
          className={`btn btn-light mr-2`}
        >
          <i className="fa fa-file-o mr-2"></i>
          Создать заявку
        </button>
      </>
    );
  };

  render() {
    const { shipId, embed } = this.props;
    const { cistern, volume, turnoverCistern, checkedCisterns } = this.state;

    const type2color = {
      "food.cistern": ["primary", "#3699ff"],
      "non-food.cistern": ["warning", "#ffa800"],
    };

    function* generateFromArray(arr) {
      let i = 0;
      let length = arr.length;
      while (true) {
        yield arr[i];
        i++;
        if (i === length) i = 0;
      }
    }

    const animateDurations = generateFromArray([
      "spd1",
      "spd3",
      "spd2",
      "spd4",
    ]);

    let colSize = embed ? 6 : 3;

    return (
      <>
        {turnoverCistern && (
          <BunkerTurnover
            cistern={turnoverCistern.id}
            onHide={this.onTurnoverClose}
            item={turnoverCistern}
          />
        )}
        <div className={embed ? "" : "container"}>
          {!embed && (
            <>
              <CrumbsProvider title="Судовой бункер" />
              <BunkerShipSelect shipId={shipId} onFinish={this.load} />
              <hr className="white" />
            </>
          )}
          <Blocker spinnerFixed hAuto on={this.state.pending}>
            {shipId && (
              <>
                {cistern.length === 0 && (
                  <DefaultNotFound message={"Сведения о бункере отсутствуют"} />
                )}
                <div className="row">
                  {cistern.map((line) => {
                    let item = line || {};
                    let vol = volume[item.id] || 0;
                    let max = item.maxvolume || 0;
                    let percent = (vol / max) * 100 || 0;
                    let { value: speed } = animateDurations.next();

                    let [color, chartColour] = type2color[item.typecode];
                    let chartData = [{ value: vol }, { value: max - vol }];

                    return (
                      <div className={`col-lg-${colSize}`} key={item.id}>
                        <div
                          className={` card card-custom wave wave-animate-${speed} wave-${color}`}
                        >
                          <div className="card-body text-center">
                            <div
                              onClick={() => this.onTurnoverOpen(item)}
                              className="cursor-pointer"
                            >
                              <div>{item.label}</div>
                              <div>
                                {vol} / {max}
                              </div>
                            </div>
                            <div
                              style={{
                                position: "relative",
                                top: "115px",
                                marginTop: "-30px",
                              }}
                            >
                              <h5>{percent.toFixed(2)}%</h5>
                            </div>
                            <PieChart
                              onClick={() => this.onTurnoverOpen(item)}
                              width={250}
                              height={200}
                              style={{
                                left: "50%",
                                marginLeft: "-125px",
                                cursor: "pointer",
                              }}
                            >
                              <Pie
                                data={chartData}
                                innerRadius={40}
                                outerRadius={60}
                                startAngle={90}
                                endAngle={450}
                                fill="#8884d8"
                                dataKey="value"
                              >
                                <Cell fill={chartColour || "#FFFFFF"} />
                                <Cell fill={"#FFFFFF"} opacity={0.7} />
                              </Pie>
                            </PieChart>
                            <div
                              className="text-left position-absolute"
                              style={{ left: "12px" }}
                            >
                              {embed ? (
                                <div></div>
                              ) : (
                                <input
                                  type="checkbox"
                                  onChange={() => this.onCisternCheck(item.id)}
                                  checked={checkedCisterns.includes(item.id)}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </Blocker>
        </div>
      </>
    );
  }
}
